/*
 * jQuery Shorten plugin 1.0.0
 *
 * Copyright (c) 2013 Viral Patel
 * http://viralpatel.net
 *
 * Dual licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 */

function init() {
	const showChar = 1000;
	const ellipsestext = "...";

	const moretext = $("#js-textReadMore").attr("data-moreText");
	const lesstext = $("#js-textReadMore").attr("data-lessText");

	$(".js-text-shorten").each(function () {
		const content = $(this).html();

		if (content.length > showChar) {
			const c = content.substr(0, showChar);
			const h = content.substr(showChar - 1, content.length - showChar);

			const html = `${c}<span class="moreellipses">${ellipsestext}</span><span class="hidden-text"><span>${h}</span>&nbsp;&nbsp;<a href="javascript:void(0)" class="[ morelink ] [ o-arrow-link  o-arrow-link--classic ]  [ u-no-wrap ]">${moretext}</a></span>`;

			$(this).html(html);
		}
	});

	$(".morelink").click(function () {
		if ($(this).hasClass("less")) {
			$(this).removeClass("less");
			$(this).html(moretext);
		} else {
			$(this).addClass("less");
			$(this).html(lesstext);
		}
		$(this).parent().prev().toggle();
		$(this).prev().toggle();
		return false;
	});
}

export { init };
